import api from './api';

const endpoint = '/contact';

export default class ContactProvider {
    sendContactForm (data) {
        return api.post(`${endpoint}`, data);
    }
}